define.alias("ember-basic-dropdown/components/basic-dropdown-wormhole", "preview-grid/components/basic-dropdown-wormhole");